import React, { useEffect, useState } from "react";
import logo from "../assets/logo.png";
import BrandPng from "../assets/images/brand.png";
// import Button from "./ui/Button";
import { useNavigate } from "react-router-dom";
import { Button, ConfigProvider } from "antd";
import { createStyles } from 'antd-style';
import { AntDesignOutlined, ArrowRightOutlined, CheckCircleTwoTone, CheckOutlined, LogoutOutlined, UserOutlined } from "@ant-design/icons";
import RequestCallbackModal from "./RequestCallbackModal";
import { useDispatch, useSelector } from "react-redux";
import ProfileMenu from "./pageComponents/ProfileMenu";
import { logout } from "../Redux Store/Slices/auth";
import { toast } from "react-toastify";
import { successToast, tempToast } from "../utils/toasts";

const useStyle = createStyles(({ prefixCls, css }) => ({
  linearGradientButton: css`
    &.${prefixCls}-btn-primary:not([disabled]):not(.${prefixCls}-btn-dangerous) {
      > span {
        position: relative;
      }

      &::before {
        content: '';
        background: linear-gradient(135deg, #14abf9, #1e40af);
        position: absolute;
        inset: -1px;
        opacity: 1;
        transition: all 0.3s;
        border-radius: inherit;
      }

      &:hover::before {
        opacity: 0;
      }
    }
  `,
}));

export default function Navbar() {
  const { user } = useSelector(state => state.auth)
  console.log({ user })
  const dispatch = useDispatch();
  const [bgColor, setBgColor] = useState('transparent');
  const [open, setOpen] = useState(false)
  useEffect(() => {
    if (window.location.hash === "#request-callback") {
      setTimeout(() => setOpen(true), 0);
    }
  }, []);

  const handleScroll = () => {
    if (window.scrollY > 0) {
      setBgColor('#00000066');
    } else {
      setBgColor('transparent');
    }
  };

  useEffect(() => {
    // Add scroll event listener when the component mounts
    window.addEventListener('scroll', handleScroll);

    // Remove event listener when the component unmounts
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const { styles } = useStyle();
  const navigate = useNavigate();
  const loginHandler = () => {
    // TEMP_CHANGES
    // navigate("/login");
    tempToast();
  };

  return <ConfigProvider
    button={{
      className: styles.linearGradientButton,
    }}
  >
    <header className="fixed top-0 left-o w-full bg-blue-950 transition-all z-50 py-4" style={{
      background: bgColor
    }} >
      <div className="section-container flex justify-between items-center w-full py-2">
        <div className="brand-wrapper flex items-center gap-1 text-white">
          {/* <img src="" alt="BRAND" /> */}
          <img src={BrandPng} alt="Pronttera Logo" className="h-8 w-8 object-contain" />
          <p className="font-medium hidden md:block ">Pronttera Labs</p>
        </div>
        <nav className="flex gap-4 items-center" >
          {user?.name ?
            null :
            <Button type="text" className="!text-white" icon={<UserOutlined />} onClick={loginHandler} >
              Login
            </Button>
          }
          <a 
          href="#courses"
          >
            <Button type="link" icon={<CheckOutlined />}
              className="!flex-row-reverse md:flex !bg-white"
            >
              Enroll Now
            </Button>
          </a>
          <RequestCallbackModal buttonComp={
            <Button type="primary" icon={<ArrowRightOutlined />} className="!flex-row-reverse md:flex hidden">
              Request Callback
            </Button>
          } />
          <RequestCallbackModal open={open} />
          {user?.name ?
            <ProfileMenu userFullName={user?.name} userName={user.email} list={[
              {
                icon: <UserOutlined />,
                label: "See Dashboard",
                onClick: () => { navigate('/dashboard/') }
              },
              {
                icon: <LogoutOutlined />,
                label: "Logout",
                onClick: () => {

                  dispatch(logout())
                }
              }
            ]} /> :
            null
          }
        </nav>
      </div>
    </header>
  </ConfigProvider>

}
